import { VoiceAgentRoom } from 'TutorBotVoiceAgent';
import { memo } from 'react';
import { type ReviewPreviousMaterialVoiceAgentAttributes } from 'TutorBotAiTutorChat';
import { ReviewPreviousMaterialIntro } from './ReviewPreviousMaterialIntro';

type Props = {
    toggleAudioOrText: () => void;
    autoStart: boolean;
    extraTokenAttributes: ReviewPreviousMaterialVoiceAgentAttributes;
};

function ReviewPreviousMaterialVoiceAgentRoomComponent({ toggleAudioOrText, autoStart, extraTokenAttributes }: Props) {
    return (
        <VoiceAgentRoom
            agentIdentifier="reviewPreviousMaterial"
            extraTokenAttributes={extraTokenAttributes}
            toggleAudioOrText={toggleAudioOrText}
            uiContext="review_previous_material_audio"
            IntroComponent={<ReviewPreviousMaterialIntro />}
            autoStart={autoStart}
        />
    );
}

export const ReviewPreviousMaterialVoiceAgentRoom = memo(
    ReviewPreviousMaterialVoiceAgentRoomComponent,
) as typeof ReviewPreviousMaterialVoiceAgentRoomComponent;
